import React, { useState, useEffect, useContext } from 'react';
import classes from "../Pages.module.css";
import { Row, Col, Skeleton, message } from "antd";
import { useNavigate, useLocation } from 'react-router-dom';
import DataContext from '../../../Context/dataContext';
import SalesTable from "./SalesTable";
import axios from 'axios';

const AllSites = () => {
  const employeeData = useContext(DataContext);
  const [columns, setColumns] = useState([]);
  const [allRows, setAllRows] = useState(null);
  const [pendingRows, setPendingRows] = useState(null);
  const [completedRows, setCompletedRows] = useState(null);
  const [type, setType] = useState("all");
  const [ft, setFT] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dFilter, setDFilter] = useState("all");
  const [typeChanged, setTypeChanged] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Get sitesList from location state or fetch if needed
  useEffect(() => {
    // Define columns
    setColumns([
      { name: "SNO", title: "SNo" },
      { name: "unit_code", title: "Unit Code" },
      { name: "unit_name", title: "Unit Name" },
      { name: "unit_address", title: "Unit Address" },
      { name: "phone_no", title: "Phone Number" },
      { name: "pan_no", title: "Pan Number" },
      { name: "gst_no", title: "Gst No" },
      { name: "pin_no", title: "Pin No" },
      { name: "city_name", title: "City" }
    ]);

    // Check if location state contains sites data
    if (location.state && location.state.SitesList && location.state.SitesList.rows) {
      // Process the sites data with the correct path
      const processedData = location.state.SitesList.rows.map((site, index) => {
        return {
          SNO: index + 1,
          ...site
        };
      });

      setAllRows(processedData);
      setPendingRows(processedData);
      setCompletedRows(processedData);
    } 
    // Alternative if your data structure is different
    else if (location.state && location.state.sitesList) {
      // Check if it's already in the correct format or if it needs extraction
      const sitesData = Array.isArray(location.state.sitesList) 
        ? location.state.sitesList 
        : (location.state.sitesList.rows || []);

      const processedData = sitesData.map((site, index) => {
        return {
          SNO: index + 1,
          ...site
        };
      });

      setAllRows(processedData);
      setPendingRows(processedData);
      setCompletedRows(processedData);
    }
  }, [location.state]);

  // Handle user selection - fetch module rights and navigate
  const handleUserSelect = async (specCode) => {
    try {
      setLoading(true);
      // API call to get modules for this user
      const response = await axios.get(`https://metalzulu-backend.onrender.com/api/v1/dashboardadmin/get-modules/${specCode}`,
          {
            withCredentials: true,
          });
      
      if (response.data) {
        console.log("API Response:", response.data);
        
        // Navigate to modules rights page with the fetched data
        navigate('/admin/modules-rights', {
          state: {
            userModules: response.data, // Pass the entire response object
            specCode: specCode
          }
        });
      } else {
        message.error("Failed to fetch module rights data");
      }
    } catch (error) {
      console.error("Error fetching module rights:", error);
      message.error("Failed to fetch module rights for this user");
    } finally {
      setLoading(false);
    }
  };

  // Custom cell formatter for the SalesTable
  const customFormatter = (row, col) => {
    if (col === "manage_rights") {
      return (
        <button 
          className={classes["ActionButton"]} 
          onClick={() => handleUserSelect(row.spec_code)}
        >
          {row[col]}
        </button>
      );
    }
    return row[col];
  };

  const handleClick = (event, val) => {
    setTypeChanged(false);
    setType(val);
    setTypeChanged(true);
  };

  const onDChange = (value) => {
    setDFilter(value);
  };

  const onDateChange = (date, dateString) => {
    setFromDate(dateString[0]);
    setToDate(dateString[1]);
  };

  // Handle back button click
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Row className={classes["Row"]}>
        <Col md={12}>
          <p className={classes["Title"]}>Sites Desc</p>
        </Col>
        <Col className={classes["Col"]} md={10}>
          <Row className={classes["Row"]}>
            <Col lg={19} md={17}></Col>
            <Col className={classes["Col"]} lg={5} md={7}>
              <button
                onClick={handleBack}
                className={classes["ProfileButton"]}
              >
                Back
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
      <p></p>
      <p></p>
      {loading ? (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      ) : typeChanged &&
        allRows &&
        completedRows &&
        pendingRows &&
        columns.length > 0 ? (
        <>
          {type === "all" && (
            <SalesTable 
              data={allRows} 
              columns={columns} 
              formatter={customFormatter} // Pass formatter function to SalesTable
            />
          )}
          {type === "pending" && (
            <SalesTable 
              data={pendingRows} 
              columns={columns} 
              formatter={customFormatter}
            />
          )}
          {type === "completed" && (
            <SalesTable 
              data={completedRows} 
              columns={columns} 
              formatter={customFormatter}
            />
          )}
        </>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default AllSites;